import React, { useState } from "react";
import styles from "./Contact.module.css";
import Textfield from "../../components/Textfield";
import TextInput from "../../components/TextInput";
import Select from "../../components/TextInput/Select";
import DatePicker from "../../components/TextInput/DatePicker";
import Button from "../../components/Buttons";
import ContactBannerIMG from "../../assets/contact/contact-background.png"
const ContactBanner = () => {
  const [date, setDate] = useState("");
  const [selectedOptionCourse, setSelectedOptionCourse] = useState("BLANK");
  const [selectedOptionPackage, setSelectedOptionPackage] = useState("BLANK");

  const options = [
    { value: "BLANK", label: "Select a Course" },
    { value: "DENTAL_COURSE", label: "Dental Clinic Course" },
    { value: "LAB", label: "Dental Lab Course" },
  ];

  const optionsPackage = [
    { value: "BLANK", label: "Select a Package" },
    { value: "DENTAL_COURSE", label: "Base Package" },
    { value: "DENTAL_COURSE", label: "“Try Me” VR Package," },
    { value: "DENTAL_COURSE", label: "“Test Me” VR Package " },

  ];
  return (
    <div id="contactus" className={styles.contactContainer}>
      <div className={styles.form}>
        <Textfield colorType="blue" type="h1">
          Take a chance for your future <br /> Book your free demo class now.
        </Textfield>
        <Textfield
          colorType="blue"
          type="h5"
          style={{ marginTop: 10, fontWeight: 400 }}
        >
          Fill in the details below and start your course. 
        </Textfield>
        <div className={styles.formMain}>
          <div className={styles.flexform}>
            <TextInput
              style={{ width: "100%" }}
              label="Name*"
              placeholder="Enter Name"
            ></TextInput>
            <TextInput
              style={{ width: "100%" }}
              label="Phone*"
              placeholder="Enter Phone"
            ></TextInput>
          </div>
          <div className={styles.flexform}>
            <Select
              value={selectedOptionCourse}
              onChange={(e) => setSelectedOptionCourse(e.target.value)}
              options={options}
              style={{ width: "100%" }}
            />
            <TextInput
              style={{ width: "100%" }}
              label="Email*"
              placeholder="Enter Email"
            ></TextInput>
          </div>
          <div className={styles.flexform}>
          <Select
              value={selectedOptionPackage}
              onChange={(e) => setSelectedOptionPackage(e.target.value)}
              options={optionsPackage}
              style={{ width: "100%" }}
            />
            {/* <DatePicker
              label="Pick a Date"
              value={date}
              style={{ width: "100%" }}
              onChange={(e) => setDate(e.target.value)}
            /> */}
          </div>
          <Button>Book Now</Button>
        </div>
      </div>
      <div className={styles.image}>
        <img
          alt="banner"
          src={ContactBannerIMG}
        />
      </div>
    </div>
  );
};

export default ContactBanner;
